import { useLendingApplicationID } from "@lending/hooks/useLendingApplicationID";
import { useApi } from "@lending/lib/api";

interface Options {
  applicationUuid?: string;
  enabled?: boolean;
}
function useListApplicationApplicantDetailsQuery(
  { applicationUuid, enabled }: Options = { enabled: true }
) {
  const $api = useApi();
  const storeApplicationId = useLendingApplicationID();
  const resolvedApplicationId = applicationUuid ?? storeApplicationId;

  return $api.useQuery(
    "get",
    "/v2/lending/application_applicant_details/",
    {
      params: {
        query: {
          application: resolvedApplicationId,
        },
      },
    },
    { enabled: Boolean(resolvedApplicationId) && enabled }
  );
}

export { useListApplicationApplicantDetailsQuery };
